import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {MatDialog} from "@angular/material/dialog";
import {TranslateModule} from "@ngx-translate/core";
import {AgendaelementModell, SaksdokumentModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {MatTooltip} from "@angular/material/tooltip";
import {OnedriveFilvelgerDialogKomponent} from "../../modale/onedrive-filvelger-dialog/onedrive-filvelger-dialog";
import {DokumentBakgrunnDirektiv, DokumentFilnavnDirektiv, DokumentHandlingDirektiv, DokumentKomponent} from "web-ng2/delt/komponenter/dokument/dokument";
import {MatIcon} from "@angular/material/icon";

const debug = initDebugger('OneDriveFilvelgerKomponent');

@Component({
    selector: 'onedrive-filvelger',
    templateUrl: 'onedrive-filvelger.html',
    styleUrl: 'onedrive-filvelger.scss',
    imports: [
        TranslateModule,
        MatTooltip,
        DokumentKomponent,
        DokumentHandlingDirektiv,
        DokumentBakgrunnDirektiv,
        DokumentFilnavnDirektiv,
        MatIcon
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OneDriveFilvelgerKomponent {
    static ajsSelector = 'onedriveFilvelger';

    @Output() vedAktivert = new EventEmitter<void>();
    @Input({required: true}) sak!: AgendaelementModell;

    constructor(private dialog: MatDialog) {
    }

    async visFilvelger() {
        OnedriveFilvelgerDialogKomponent.vis(this.dialog, this.sak.id, this.sak.moete.id, (filnavn: string) => this.eksisterendeDokument(filnavn))
        this.vedAktivert.emit();
    }

    // private hjelpemetoder

    /** Returnerer eventuelt eksisterende saksdokument med samme filnavn.
     * Gjør case-sensitiv sammenlikning - slik er det også ved opplasting av dokumenter fra bruker disk.. */
    private eksisterendeDokument(filnavn: string): SaksdokumentModell | null {
        return this.sak.dokumenter.find(eksisterende => eksisterende.filnavn == filnavn) ?? null;
    }
}


